import { GET_TYPED_ASYNC } from '../helpers/httpHelper';

const BASE_PATH = 'api/Cep';

export interface ICepResponse {
	success: boolean;
	cep?: ICep;
	error?: string;
}

const getCep = async (cep: string): Promise<ICepResponse> => {
	try {
		const response = await GET_TYPED_ASYNC<ICep>(`${BASE_PATH}/${cep}`);

		if (response && response.success) {
			return { success: response.success, cep: response.entity };
		} else {
			return { success: response.success, error: response.message };
		}
	} catch (err: any) {
		return { success: false, error: err.message };
	}
};

export default {
	getCep,
};
